import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

import { AuthService, BaseFilterCollapse, BaseFilterCollapseService, ConfigService, MessageService } from '../../../../core';
import { EnumCadastro as EnumTagCadastro } from '../../../../domains/environment/tags/enums/cadastro.enum';
import { EnumUsuarioPerfil } from '../../../../domains/shared/components/usuario-multi-select/enums/usuario-perfil.enum';
import { EnumSituacao as EnumTagSituacao } from '../../../../domains/shared/enums/situacao.enum';
import { periodicidadeMensal } from '../../../../shared';
import { DatepickerComponent, datepickerModePeriodicidade } from '../../../../shared/components/datepicker';
import { Cidade } from '../../../cidade';
import { ConfigEmpresa } from '../../../configuracoes/app/empresa';
import { Item } from '../../../item';
import { Pessoa } from '../../../pessoa';
import { referencias } from '../referencia';
import { CurvaAbcVendaFilterInitialization } from './curva-abc-venda-filter-initialization';
import { CurvaAbcVendaFilter } from './curva-abc-venda-filter';
import { CurvaAbcVendaFilterStorageService } from './services';

@Component({
    selector: 'sgt-curva-abc-venda-filter',
    templateUrl: './curva-abc-venda-filter.component.html',
    styleUrls: ['./curva-abc-venda-filter.component.less']
})
export class CurvaAbcVendaFilterComponent implements BaseFilterCollapse, OnInit, OnChanges, AfterViewInit, OnDestroy {
    configEmpresa: ConfigEmpresa;
    isRepresentante: boolean;

    @Input() filter: CurvaAbcVendaFilter;
    @Input() initialization: CurvaAbcVendaFilterInitialization;
    @Output() filterChange = new EventEmitter<any>();
    @Output() filterCleaned = new EventEmitter<any>();
    @Input() isShowClienteFilter = true;
    @Input() filterStorageKey: string = null;
    referencias = referencias;
    // ordersBy = ordersBy;

    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';
    isFilterDirty = false;

    // Data Emissão Datepicker
    dataEmissaoDatepickerMode = datepickerModePeriodicidade.id;
    isFirstChangeDataEmissao = true;
    @ViewChild('dataEmissaoDatepicker') dataEmissaoDatepicker: DatepickerComponent;

    // Multiselects
    isFirstChangeRepresentanteMultiselect = true;
    isFirstChangeClassificacoesClientesMultiselect = true;
    isFirstChangeClassificacoesItensMultiselect = true;
    isFirstChangeTagsClientesMultiselect = true;
    isFirstChangeTagsItensMultiselect = true;

    readonly EnumUsuarioPerfil = EnumUsuarioPerfil;
    readonly EnumSituacao = EnumTagSituacao;

    // Tags
    tagCadastroItem = EnumTagCadastro.ITEM;
    tagCadastroCliente = EnumTagCadastro.CLIENTE;
    tagSituacaoAtivo = EnumTagSituacao.ATIVO;

    constructor(private authService: AuthService,
                private messageService: MessageService,
                private baseFilterCollapseService: BaseFilterCollapseService,
                private configService: ConfigService,
                private curvaAbcVendaFilterStorageService: CurvaAbcVendaFilterStorageService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isRepresentante = this.authService.isRepresentante();

        this.curvaAbcVendaFilterStorageService.applyFilter(this.filter, this.filterStorageKey);
        this.initFilter();
    }

    ngAfterViewInit() {
      if (!this.isCollapsedInDefault) {
        jQuery(this.filterCollapse.nativeElement).css('display', 'none');
      }
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }


    /** Inicializa o filtro */
    private initFilter() {
        setTimeout(() => {
            // Setando o mês atual quando o filtro não possuir a periodicidade de emissão
            if (!this.filter.possuiPeriodicidadeEmissao()) {
                this.setMesEmissaoAtual();
            }

            this.initialization.initializeMain();
        }, 200);
    }

    /** Emite evento de alteração no filtro para atualizar a pesquisa */
    refresh() {
        this.close();
        this.filterChange.emit();
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }

    /** Limpa o filtro e atualiza a pesquisa */
    clear() {
        // Removendo os filtros
        this.baseFilterCollapseService.clear(this);

        this.refresh();
    }

    /** Seta o foco no datepicker da data de emissão */
    setFocusDataEmissaoDatepicker() {
        this.dataEmissaoDatepicker?.setFocus();
    }

    /** Seta a data do filtro com periodicidade mensal e com o mês atual */
    setMesEmissaoAtual() {
        const data = new Date();
        data.setDate(1); // Setando sempre o dia 1;

        this.dataEmissaoDatepicker?.setPeriodicidade(periodicidadeMensal, data);
    }

    /** Ao alterar a data de emissao */
    onChangeDataEmissao() {
        if (this.isFirstChangeDataEmissao) {
            this.isFirstChangeDataEmissao = false;
            return;
        }

        this.filterChange.emit();
    }

    /** Ao alterar a data inicial do período de emissão */
    onChangeDataEmissaoInicialPeriodo() {
        this.filterChange.emit();
    }

    /** Ao alterar a data final do período de emissão */
    onChangeDataEmissaoFinalPeriodo() {
        this.filterChange.emit();
    }

    /** Ao alterar as classificações */
    onChangeClassificacoes(idsClassificacoes: number[]) {
        if (idsClassificacoes && idsClassificacoes.length > 0) {
            this.isFilterDirty = true;
        }
    }

    /** Ao alterar o multiselect dos status dos pedidos */
    onChangeStatusesPedidos() {
        this.filter.isFilterDirty = true;
        this.filterChange.emit();
    }

    /** Ao alterar os representantes */
    onChangeRepresentantes() {
        if (this.isFirstChangeRepresentanteMultiselect) {
            this.isFirstChangeRepresentanteMultiselect = false;
            return;
        }

        this.filter.isFilterDirty = true;
        this.filterChange.emit();
    }

    /** Ao alterar os gerentes */
    onChangeGerentes() {
        this.filter.isFilterDirty = true;
        this.filterChange.emit();
    }

    /** Ao alterar os atendentes */
    onChangeAtendentes() {
        this.filter.isFilterDirty = true;
        this.filterChange.emit();
    }

    /** Ao alterar as classificações de clientes */
    onChangeClassificacoesClientes() {
        if (this.isFirstChangeClassificacoesClientesMultiselect) {
            this.isFirstChangeClassificacoesClientesMultiselect = false;
            return;
        }

        this.filter.isFilterDirty = true;
        this.filterChange.emit();
    }

    /** Ao alterar as classificações */
    onChangeClassificacoesItens() {
        if (this.isFirstChangeClassificacoesItensMultiselect) {
            this.isFirstChangeClassificacoesItensMultiselect = false;
            return;
        }

        this.filter.isFilterDirty = true;
        this.filterChange.emit();
    }

    /** Ao alterar as tags de clientes */
    onChangeTagsClientes() {
        if (this.isFirstChangeTagsClientesMultiselect) {
            this.isFirstChangeTagsClientesMultiselect = false;
            return;
        }

        this.filter.isFilterDirty = true;
        this.filterChange.emit();
    }

    /** Ao alterar as tags de itens */
    onChangeTagsItens() {
        if (this.isFirstChangeTagsItensMultiselect) {
            this.isFirstChangeTagsItensMultiselect = false;
            return;
        }

        this.filter.isFilterDirty = true;
        this.filterChange.emit();
    }

    /** Ao alterar o cliente/pessoa */
    onChangeCliente(pessoa: Pessoa) {
        if (pessoa) {
            this.filter.idPessoa = pessoa.id;
            this.isFilterDirty = true;
        } else {
            this.filter.idPessoa = null;
        }
    }

    /** Ao alterar o item */
    onChangeItem(item: Item) {
        if (item) {
            this.filter.idItem = item.id;
            this.isFilterDirty = true;
        } else {
            this.filter.idItem = null;
        }
    }

    /** Ao alterar a cidade */
    onChangeCidade(cidade: Cidade) {
        if (cidade) {
            this.filter.idCidade = cidade.id;
            this.isFilterDirty = true;
        } else {
            this.filter.idCidade = null;
        }
    }

    /** Ao alterar os estados */
    onChangeEstados(idsEstados: number[]) {
        if (idsEstados && idsEstados.length > 0) {
            this.isFilterDirty = true;
        }
    }

    ngOnDestroy() {
        this.curvaAbcVendaFilterStorageService.remove(this.filterStorageKey);
    }
}
